
<div style="display: flex; justify-content: center; margin-top:0.5em;">
  <div class="label-container">
    <mat-label>
      {{ 'Devices.DeviceDetail' | translate }}
    </mat-label>
  </div>
</div>

<div class="main-container" *ngIf="device$ | async as device">

  <div id="device-fields">
    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.FleetName' | translate }}</mat-label>
      <input matInput type="text" [value]="device.nomeFlotta" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.VehicleName' | translate }}</mat-label>
      <input matInput type="text" [value]="device.nomeMezzo" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.VehicleLicensePlate' | translate }}</mat-label>
      <input matInput type="text" [value]="device.targa" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.VehicleBrand' | translate }}</mat-label>
      <input matInput type="text" [value]="device.marca" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.VehicleModel' | translate }}</mat-label>
      <input matInput type="text" [value]="device.modello" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.LockStatus' | translate }}</mat-label>
      <input matInput type="text" [value]="device.lockInput?.fieldValue ?? '-'" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.DoorStatus' | translate }}</mat-label>
      <input matInput type="text" [value]="device.doorInput?.fieldValue ?? '-'" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" subscriptSizing="dynamic">
      <mat-label>{{ 'Devices.DeviceDateTime' | translate }}</mat-label>
      <input matInput type="text" [value]="device.statoDateTime | date:'dd/MM/yyyy HH:mm:ss'" readonly/>
    </mat-form-field>

    <mat-form-field class="normal-mat-select-group normal-form-field" *ngIf="device.lockOutput" subscriptSizing="dynamic">
      <mat-label> {{ 'Devices.DeviceType' | translate }} </mat-label>
      <input matInput type="text" [value]=" (device.lockOutput!.isManual) ? ('Devices.DeviceTypeManual' | translate) : ('Devices.DeviceTypeAutomatic' | translate)" readonly/>
    </mat-form-field>
  </div>

  <div class="buttons-container">
    <div class="button-slot">
      <button mat-raised-button (click)="onCancel()">
        {{ 'Main.Button.Cancel' | translate }}
      </button>
    </div>
    <div class="button-slot">
      <button mat-raised-button
        *ngIf="device.lockOutput && isLockButtonVisible(device) && isLockButtonEnabled"
        type="submit" (click)="onLock(device)">

        <mat-icon *ngIf="!device.lockOutput.rawValue">lock_open</mat-icon>
        <mat-icon *ngIf="device.lockOutput.rawValue">lock</mat-icon>
        <span>{{device.lockOutput.fieldValue}}</span>
      </button>
      <span *ngIf="!isLockButtonEnabled">
        <mat-spinner [diameter]="40"></mat-spinner>
      </span>
    </div>
  </div>

  <div *ngIf="!device.lockOutput">
    ⚠️ {{ 'Devices.Error.NoLockOutputFound' | translate }}
  </div>

</div>
